import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboard, PackagePlus, Upload, ListChecks, Bot } from 'lucide-react';
import { cn } from '@/lib/utils';

const TABS = [
  { to: '/dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { to: '/shipments/new', label: 'Shipment', icon: PackagePlus },
  { to: '/shipments/bulk', label: 'Bulk', icon: Upload },
  { to: '/scope3/activities', label: 'Activities', icon: ListChecks },
  { to: '/shanthi', label: 'Ask Trace', icon: Bot },
];

/** Phones only: a floating glass tab bar for the five most-used destinations (the menu drawer stays). */
export default function MobileTabBar() {
  return (
    <nav aria-label="Primary" className="mobile-tabbar md:hidden">
      {TABS.map(({ to, label, icon: Icon }) => (
        <NavLink
          key={to}
          to={to}
          className={({ isActive }) => cn('mobile-tabbar__item', isActive && 'mobile-tabbar__item--active')}
        >
          <Icon className="h-5 w-5" aria-hidden="true" />
          <span>{label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
